<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2 class="page__title">Добавить сотрудника</h2>
        <el-tabs>
          <el-tab-pane label="Настройка">
            <el-form
              class="page__form"
              id="formCreateClient"
              :model="user"
              ref="form"
              :rules="rules"
              label-position="right"
              label-width="180px"
            >
              <el-form-item label="Имя" prop="client_name">
                <el-input id="client_name" size="small" v-model="user.client_name" />
              </el-form-item>
              <el-form-item label="" prop="email">
                <span slot="label">Email <br/> (Логин для авторизации)</span>
                <el-input id="email" size="small" v-model="user.email" />
              </el-form-item>
              <el-form-item label="Уведомления" prop="email_notification">
                <el-switch
                  id="notification"
                  size="small"
                  :active-value="1"
                  :inactive-value="0"
                  v-model="user.email_notification"
                />
              </el-form-item>
              <el-form-item label="Пароль" prop="password">
                <el-input id="password" size="small" v-model="user.password">
                  <el-button @click="generatePassword" slot="append" type="primary">Создать пароль</el-button>
                </el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-button class="page__active_button" id="submit" icon="el-icon-check" type="primary" @click="submit">
        Добавить
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapActions } from "vuex";
import { required, length, validatorSpace, validatorAllLatine } from "@/core/helpers/validators";

export default {
  name: "FormCreateUser",
  data() {
    return {
      user: {
        client_name: "",
        email: "",
        email_notification: 0,
        password: "",
      },
      rules: {
        client_name: [required(), length(4, 100)],
        email: [required(), validatorSpace],
        password: [required(), length(5, 100), validatorSpace, validatorAllLatine],
      },
    };
  },
  methods: {
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.create(this.user)
            .then((id) => {
              this.$message({
                message: "Сотрудник успешно создан",
                type: "success",
              });
              this.$router.push({ name: "user:edit", params: { id } });
            })
            .catch((e) => {
              this.$message.error(e.response.data.error || "Ошибка при добавлении сотрудника");
            });
        }
        return valid;
      });
    },
    generatePassword() {
      const length = 8;
      const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let password = "";

      for (var i = 0, n = charset.length; i < length; ++i) {
        password += charset.charAt(Math.floor(Math.random() * n));
      }

      this.user.password = password;
    },
    ...mapActions("user", {
      create: "ADD_USER",
    }),
  },
};
</script>
